import queryString from 'query-string';

import fetchQuery from 'rebook/apps/utils/fetchQuery';
import * as SeoActions from 'rebook/apps/base/actions/SeoActions';
import * as Error404Actions from 'rebook/apps/base/actions/Error404Actions';
import truncateChars from 'rebook/apps/utils/text/truncateChars';
import {
  CATALOG_AUTHOR_REVIEWS_SET_DATA,
  CATALOG_AUTHOR_REVIEWS_RESET_DATA,
} from 'rebook/apps/catalog/constants';
import { Author } from 'rebook/apps/catalog/models';


export function fetchInitialData(match, location = {}) {
  return async(dispatch, getState) => {
    const { ssr, authorReviewList: currentState } = getState();
    const pageNumber = ssr.query && ssr.query.page
      ? parseInt(ssr.query.page, 10)
      : 1;

    const { authorSlug } = match.params;

    let newState = {
      authorSlug,
    };

    if (location && location.state) {
      newState = {
        ...newState,
        ...location.state,
      };
    }
    if (currentState.reviews) {
      newState = {
        ...newState,
        ...currentState,
      };
    }

    // set partial state (it could probably be the data obtained from router)
    dispatch(setData(newState));

    if (!newState.author) {
      await dispatch(fetchAuthor(match));
    }
    if (!newState.reviews || currentState.pageNumber !== pageNumber) {
      await dispatch(fetchAuthorReviewList(pageNumber));
    }
  };
}

export function fetchAuthor(match) {
  return async(dispatch, getState) => {
    const { ssr } = getState();
    const { authorSlug } = match.params;
    const url = `/api/authors/s-${authorSlug}/`;
    return await fetchQuery(url, { apiVersion: 4, headers: ssr.headers })
      .then(
        ({ data }) => {
          dispatch(setData({ author: data }));
        }
      )
      .catch(
        ({ data, resp, error }) => {
          if (resp.status === 404) {
            dispatch(Error404Actions.show());
          }
          else {
            Raven.captureMessage('failed to load review list for author due to server error', {
              level: 'error',
              extra: {
                status: resp.status,
                response: data,
                error,
              },
            });
            throw new Error('failed to load review list detail due to server error');
          }
        }
      );
  };
}

export function fetchAuthorReviewList(pageNumber = 1) {
  return async(dispatch, getState) => {
    const { authorReviewList, ssr } = getState();
    const { author } = authorReviewList;
    if (!author) {
      return;
    }
    // optimistically update the UI
    dispatch(setData({
      reviews: null,
      pageNumber,
    }));
    const limit = 10;
    let queryParams = {
      author: author.id,
      html: 1,
      limit,
      offset: (pageNumber - 1) * limit,
    };

    const qs = queryString.stringify(queryParams);
    const url = `/api/book-reviews/?${qs}`;

    return await fetchQuery(url, { apiVersion: 2, headers: ssr.headers })
      .then(
        ({ data }) => {
          const lastPageNumber = Math.ceil(data.meta.total_count / limit);
          dispatch(setData({
            reviews: data.objects,
            pageNumber,
            lastPageNumber,
          }));
        }
      )
      .catch(
        ({ data, resp, error }) => {
          Raven.captureMessage('failed to load review list due to server error', {
            level: 'error',
            extra: {
              status: resp.status,
              response: data,
              error,
            },
          });
          throw new Error('failed to load review list detail due to server error');
        }
      );
  };
}

function setSeoMeta() {
  return (dispatch, getState) => {
    const { authorReviewList, booksPerSubscriptionCounter } = getState();
    const { reviews } = authorReviewList;
    const author = new Author(authorReviewList.author);
    const desktopUrl = `https://${BASE_HOST}${author.getReviewListUrl()}`;
    const authorUrl = `https://${BASE_HOST}${author.absolute_url}`;
    const title = `Отзывы о творчестве ${author.cover_name} - мнения читателей — MyBook`;
    const description = truncateChars(
      `В электронной библиотеке MyBook можно прочитать более ${booksPerSubscriptionCounter.total} ` +
      `электронных книг. Для онлайн чтения доступны шедевры современной ` +
      `и классической литературы. Новинки и бестселлеры, отзывы, рекомендации, популярные авторы.`,
      300
    );
    dispatch(SeoActions.setData({
      canonicalUrl: reviews && reviews.length ? desktopUrl: authorUrl,
      title,
      description,
    }));
  };
}

export function setData(payload) {
  return (dispatch) => {
    const { reviews } = payload;
    dispatch({
      type: CATALOG_AUTHOR_REVIEWS_SET_DATA,
      payload,
    });
    if (reviews) {
      dispatch(setSeoMeta());
    }
  };
}

export function resetData() {
  return (dispatch) => {
    dispatch(SeoActions.resetData());
    dispatch({
      type: CATALOG_AUTHOR_REVIEWS_RESET_DATA,
    });
  };
}
